import { Resources, type TFunction } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Auth.Migration.MerchantCreateIdentity;

export const formatPersonName = (
  t: TFunction,
  firstName?: string | null,
  lastName?: string | null,
) => {
  const name = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  return name.length > 0 ? name : t(COMPONENT_RESOURCES.UnnamedPerson);
};

export const localizeRelationType = (t: TFunction, relationType: string) => {
  const key = relationType as keyof typeof COMPONENT_RESOURCES.RelationTypes;
  const localized = COMPONENT_RESOURCES.RelationTypes[key];
  return localized !== undefined ? t(localized) : relationType;
};
